import { event } from '@rategravity/frontend/modules/user-actions';
import colors from '@rategravity/frontend/theme/colors';
import CircularProgress from 'material-ui/CircularProgress';
import Dialog from 'material-ui/Dialog';
import React from 'react';
import MediaQuery from 'react-responsive';
import Scroll from 'react-scroll';
import 'rxjs/add/operator/first';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/timer';
import 'rxjs/add/observable/zip';
import { Observable } from 'rxjs/Observable';
import RelayEnvironment from '../relay-environment';
import './style.styl';

const scroll = Scroll.animateScroll;
const style = {
  content: {
    maxWidth: 500,
    width: '85%'
  },
  title: {
    marginBottom: '1em'
  },
  loading: {
    display: 'flex',
    height: 250,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    paddingTop: '30px'
  },
  body: {
    color: colors.primary,
    textAlign: 'center',
    padding: '1em'
  },
  background: {
    backgroundColor: colors.white,
    height: '100%',
    width: '100%'
  },
  container: {
    color: colors.primary
  },
  overlay: {
    backgroundColor: '#fff',
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 50
  }
};

const defaultMessageSmallScreen = <h5 style={style.title}>Processing Your Information</h5>;
const defaultMessageLargeScreen = <h4 style={style.title}>Processing Your Information</h4>;

/**
 * Generates an element representing the animated component of
 * the thinking screen.
 * For each message in the thinking screen:
 *   - fade in after 0.25s. Fade-in duration is 0.5s.
 *   - persist. All messages except the last persist for 1s.
 *     The last message persists perpetually.
 *   - fade out, after persistence. Fade-out duration is 0.5s.
 *     (The last message does not fade out)
 * @screenSteps Array of elements. E.g., <h2>MESSAGE<h2>
 *   - takes elements so that the messages can be custom-styled.
 */
export const thinkingScreen = (screenSteps) => (
  <div className="thinkingScreen">
    {screenSteps.map((step, index) => (
      <div
        className="loading"
        key={index}
        style={{
          ...(index < screenSteps.length - 1
            ? {
                animationDelay: `${2 * index + 0.25}s, ${2 * index + 1.75}s`,
                animationName: 'fadeIn, fadeOut'
              }
            : {
                animationDelay: `${2 * index + 0.25}s`,
                animationName: 'fadeIn'
              })
        }}
      >
        {step}
      </div>
    ))}
  </div>
);

/**
 * Effects the Thinking Screen modal.
 *
 * The following props are passed in:
 * @param {RxJS.ReplaySubject} actionPipe - Used to emit values to MixPanel
 * @param {function} mutation - Used to invoke CompleteMutation
 * @param {function} done - Used as a callback after the mutations are completed.
 * @param {string[]} messages - Messages to display for the Thinking Screen animation.
 */
export default class extends React.Component {
  componentWillMount() {
    const { done, mutation } = this.props;
    Observable.zip(
      RelayEnvironment.allMutationsComplete()
        .first()
        .mergeMap(() => Observable.fromPromise(mutation())),
      Observable.timer(6000) // Accommodates a thinking screen with three steps.
    ).subscribe(done, done);
  }

  componentDidMount() {
    this.props.actionPipe.next(event('Mount Thinking Screen Component'));
    scroll.scrollTo(0, {
      duration: 100,
      smooth: true
    });
  }

  componentWillUnmount() {
    this.props.actionPipe.next(event('Unmount Thinking Screen Component'));
    scroll.scrollTo(0, {
      duration: 100,
      smooth: true
    });
  }

  render() {
    return (
      <div>
        <div style={style.overlay} />
        <div style={style.container}>
          <div style={style.background} />
          <Dialog
            open
            autoDetectWindowHeight
            modal
            style={style.dialog}
            repositionOnUpdate
            contentStyle={style.content}
            bodyStyle={style.body}
          >
            <MediaQuery maxWidth={719}>
              {this.props.messages
                ? thinkingScreen(this.props.messages)
                : defaultMessageSmallScreen}
            </MediaQuery>
            <MediaQuery minWidth={720}>
              {this.props.messages
                ? thinkingScreen(this.props.messages)
                : defaultMessageLargeScreen}
            </MediaQuery>
            <div style={style.loading}>
              <CircularProgress size={80} thickness={6} />
            </div>
          </Dialog>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/loading.js